var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tw-flex tw-flex-col tw-items-center tw-gap-4 content-marker"},[_c('span',{staticClass:"text-1-8 tw-font-bold"},[_vm._v(" "+_vm._s(_vm.dateEvent.adresse))]),_c('span',{staticClass:"text-1-8 tw-font-bold tw-mb-4"},[_vm._v(" "+_vm._s(_vm.dateEvent.codePostal)+" - "+_vm._s(_vm.dateEvent.ville)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }